import $ from 'jquery';

const mobileMenuSearchTrigger = () => {
    const $searchTrigger = $('.c-mobile-menu-search-trigger');
    const $mobileSearchInput = $('.mobile-search-container .search-input');
    const $mobileSearchContainer = $('.mobile-search-container');
    const activeClass = 'is-active';

    if (!$searchTrigger.length) {
        return;
    }

    $searchTrigger.on('click', () => {
        $mobileSearchContainer.toggleClass(activeClass);
        if ($mobileSearchContainer.hasClass(activeClass)) {
            $mobileSearchInput.trigger('focus');
        }
    });
};

// doc ready
$(() => {
    mobileMenuSearchTrigger();
});
